import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useTr, fmtDate } from "@/lib/tr";
import { inputDark } from "@/components/shared/AdminKit";
import { Loader2 } from "lucide-react";

function LogList({ items, tr, showUser }) {
  if (!items.length) return <div className="mt-6 rounded-xl border border-slate-800 bg-slate-900 py-12 text-center text-sm text-slate-500">{tr("Aucune activité enregistrée.", "No activity recorded.")}</div>;
  return (
    <div className="mt-4 divide-y divide-slate-800 rounded-xl border border-slate-800 bg-slate-900">
      {items.map((l, i) => (
        <div key={i} className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 text-sm" data-testid={`history-${i}`}>
          <div><span className="font-medium text-white">{l.action}</span> <span className="text-slate-500">· {l.entity}</span>{showUser && <span className="text-xs text-slate-500"> · {l.user_email}</span>}</div>
          <div className="text-xs text-slate-500">{fmtDate(l.created_at, tr.lang)}</div>
        </div>
      ))}
    </div>
  );
}

export default function AgentHistory() {
  const tr = useTr();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/agent/activity").then((r) => setData(r.data)).catch(() => setData({ items: [] })); }, []);
  if (data === null) return <div className="py-20 text-center"><Loader2 className="mx-auto h-7 w-7 animate-spin text-accent" /></div>;
  return (
    <div data-testid="agent-history">
      <h1 className="font-display text-2xl font-bold">{tr("Mon historique", "My history")}</h1>
      <p className="mt-1 text-sm text-slate-400">{tr("Vos actions récentes sur la plateforme.", "Your recent actions on the platform.")}</p>
      <LogList items={data.items} tr={tr} />
    </div>
  );
}

export function AgentTeamActivity() {
  const tr = useTr();
  const [agent, setAgent] = useState("");
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/agent/team-activity", { params: { agent_id: agent || undefined } }).then((r) => setData(r.data)).catch(() => setData({ items: [], agents: [] })); }, [agent]);
  if (data === null) return <div className="py-20 text-center"><Loader2 className="mx-auto h-7 w-7 animate-spin text-accent" /></div>;
  return (
    <div data-testid="agent-team-activity">
      <h1 className="font-display text-2xl font-bold">{tr("Activité des agents", "Agents activity")}</h1>
      <select value={agent} onChange={(e) => setAgent(e.target.value)} className={inputDark + " mt-4 w-auto"} data-testid="team-activity-agent">
        <option value="">{tr("Tous les agents", "All agents")}</option>
        {(data.agents || []).map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
      </select>
      <LogList items={data.items} tr={tr} showUser />
    </div>
  );
}
